import { useEffect, useRef } from 'react';
import { useFilterSearchQuery } from '../useFilterSearchQuery';

export function useFilterInitialValue(key: string, callback: (values: string[][]) => void) {
  const initialRef = useRef(false);
  const { values } = useFilterSearchQuery(key);
  useEffect(() => {
    if (!initialRef.current && values.length > 0) callback(values);
    initialRef.current = true;
  }, [values]);
}
